// Personenwahl der Inbox (I-14): „Meine“, die Inbox einer anderen Person oder „Alle“. Wie in Close als Pille mit Avatar
// und Namen rechts über der Liste. Nur mit dem Recht, Aufgaben anderer zu sehen (manage_others_tasks); sonst zeigt die
// Seite nur die eigene Inbox und diese Pille gar nicht.
import { useAuth } from "../../auth/AuthContext";
import { useMeta } from "../../daten/meta";
import { Avatar } from "../Bausteine";
import { Icon } from "../Icon";
import { MenueKnopf, type MenuePunkt } from "../Menue";
import "./inbox.css";

/** Darf die angemeldete Person fremde Inboxen sehen? */
export function useDarfFremde(): boolean {
  const { nutzer } = useAuth();
  return !!nutzer?.permissions?.includes("manage_others_tasks");
}

interface Props {
  /** "me", "all" oder die Close-ID eines Nutzers */
  wer: string;
  onWahl: (wer: string) => void;
}

export function PersonenWahl({ wer, onWahl }: Props) {
  const { nutzer } = useAuth();
  const meta = useMeta();
  const ich = nutzer?.close_user_id ?? nutzer?.id ?? "";
  const andere = meta.nutzerListe.filter((u) => u.is_active && u.id !== nutzer?.id && (u.close_user_id ?? u.id) !== ich);
  const gewaehlt = wer === "me" || wer === ich ? null : wer === "all" ? "all" : (meta.nutzer(wer) ?? null);
  const name = wer === "me" || wer === ich ? (nutzer?.name ?? "Ich") : wer === "all" ? "Alle" : gewaehlt && gewaehlt !== "all" ? gewaehlt.name : "Unbekannt";
  const punkte: MenuePunkt[] = [
    { label: "Inbox von", ueberschrift: true },
    { label: `Meine (${nutzer?.name ?? "ich"})`, icon: "person", rechts: wer === "me" || wer === ich ? "✓" : undefined, onClick: () => onWahl("me") },
    ...andere.map<MenuePunkt>((u) => ({
      label: u.name,
      icon: "person",
      rechts: wer === (u.close_user_id ?? u.id) ? "✓" : undefined,
      onClick: () => onWahl(u.close_user_id ?? u.id),
    })),
    { label: "Alle zusammen", icon: "leads", trenner: true, rechts: wer === "all" ? "✓" : undefined, onClick: () => onWahl("all") },
  ];
  return (
    <MenueKnopf knopfKlasse="personenwahl" titel="Inbox einer anderen Person ansehen" ausrichtung="end" breite={230} punkte={punkte}>
      {wer === "all" ? <Icon name="leads" groesse={14} /> : <Avatar name={name} id={wer === "me" ? ich : wer} groesse={18} />}
      <span className="personenwahl__name">{wer === "me" || wer === ich ? "Meine" : name}</span>
      <Icon name="chevron-unten" groesse={12} />
    </MenueKnopf>
  );
}
